/// <amd-module name="TFS/Admin/Views/OrgGroups/redux/OrganizationGroupsReducer" />
import produce from "immer";

import { GroupsNavType } from "TFS/Admin/Groups/Common/Constants";
import { IGroupsPageState } from "TFS/Admin/Groups/Common/Contracts";
import { GroupsViewActions, GroupsViewActionTypes } from "TFS/Admin/Groups/Common/Redux/Actions/GroupsViewActions";

export function organizationGroupsReducer(state: IGroupsPageState, action: GroupsViewActions): IGroupsPageState {
    return produce(state || {}, draft => {
        switch (action.type) {
            case GroupsViewActionTypes.InitialLoadSucceeded: {
                const { isCollectionNavigationAllowed, scopeDescriptor } = action.payload;
                draft.isCollectionNavigationAllowed = isCollectionNavigationAllowed;
                draft.scopeDescriptor = scopeDescriptor;
                draft.selectedNavType = GroupsNavType.Default;
                draft.invalidMembers = [];
                draft.validMembers = [];
                break;
            }

            case GroupsViewActionTypes.SelectedGroupChanged: {
                const group = action.payload;
                draft.selectedGroup = group;
                draft.selectedNavType = GroupsNavType.GroupDetails;
                draft.selectedUser = undefined;
                break;
            }

            case GroupsViewActionTypes.SelectedUserChangedSuccessful: {
                draft.selectedUser = action.payload;
                draft.selectedNavType = GroupsNavType.UserDetails;
                draft.selectedGroup = undefined;
                break;
            }

            case GroupsViewActionTypes.SelectedServicePrincipalChangedSuccessful: {
                draft.selectedUser = action.payload;
                draft.selectedNavType = GroupsNavType.ServicePrincipalDetails;
                draft.selectedGroup = undefined;
                break;
            }

            case GroupsViewActionTypes.SelectedMemberChangedSuccessful: {
                draft.selectedMember = action.payload;
                draft.selectedNavType = GroupsNavType.MemberDetails;
                draft.selectedGroup = undefined;
                break;
            }

            case GroupsViewActionTypes.SelectedGroupPermissionsUpdate: {
                const { descriptor, permissions } = action.payload;
                if (draft.selectedGroup && draft.selectedGroup.descriptor === descriptor) {
                    draft.selectedGroup.actionPermissions = permissions;
                }
                break;
            }

            case GroupsViewActionTypes.GroupEdited: {
                const graphGroup = action.payload;
                if (draft.selectedGroup) {
                    draft.selectedGroup.displayName = graphGroup.displayName;
                    draft.selectedGroup.principalName = graphGroup.principalName;
                    draft.selectedGroup.description = graphGroup.description;
                }
                break;
            }

            case GroupsViewActionTypes.GroupAvatarUpdatedUrl: {
                draft.updatedAvatarUrl = action.payload;
                break;
            }

            case GroupsViewActionTypes.SetFilterPlaceHolder: {
                const placeholder: string = action.payload;
                draft.filterPlaceHolder = placeholder;
                break;
            }

            case GroupsViewActionTypes.SetPermissionsMarkTTI: {
                draft.toMarkPermissionsTTI = true;
                break;
            }

            case GroupsViewActionTypes.SetURLRedirectFlag: {
                draft.isURLRedirect = true;
                break;
            }

            case GroupsViewActionTypes.OpenAddMemberPanel: {
                draft.showAddMemberPanel = true;
                draft.invalidMembers = [];
                draft.validMembers = [];
                break;
            }

            case GroupsViewActionTypes.CloseAddMemberPanel: {
                draft.showAddMemberPanel = false;
                break;
            }

            case GroupsViewActionTypes.ClosePCAMessageBar: {
                draft.pcaGroup = undefined;
                break;
            }

            case GroupsViewActionTypes.SetPcaGroupSuccess: {
                const { pcaGroup } = action.payload;
                draft.pcaGroup = pcaGroup;
                break;
            }

            case GroupsViewActionTypes.AddInvalidMember: {
                const { member } = action.payload;
                if (draft.validMembers.findIndex(x => x.entityId === member.entityId) == -1) {
                    draft.validMembers.push(member);
                    draft.invalidMembers.push(member);
                }
                break;
            }

            case GroupsViewActionTypes.AddValidMember: {
                const { member } = action.payload;
                if (draft.validMembers.findIndex(x => x.entityId === member.entityId) == -1) {
                    draft.validMembers.push(member);
                }
                break;
            }

            case GroupsViewActionTypes.RemoveMembers: {
                draft.validMembers = draft.validMembers.filter(
                    entity => action.payload.members.filter(item => item.entityId === entity.entityId).length === 0
                );
                draft.invalidMembers = draft.invalidMembers.filter(
                    entity => action.payload.members.filter(item => item.entityId === entity.entityId).length === 0
                );
                break;
            }

            default:
                return state;
        }
    });
}
